import { Badge, Dialog, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import React, { useEffect } from 'react';
import { IoFunnelSharp } from 'react-icons/io5';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { FILTER_ALLERGENS, AllergenItem, INGREDIENTS } from '../../constants/base-data.constant';
import i18n from '../../i18n';
import './menu-allergen-filter.scss';
import useSetState from '../../tools/hooks/useSetState';
import { CloseSharp } from '@material-ui/icons';
import ServerShoppingCart from '../../modules/server-shopping-cart';

export function MenuAllergenFilter({
    onReRender,
}: Props) {
    const [state, setState] = useSetState<State>({
        open: false,
        allergens: FILTER_ALLERGENS,
        selectedAllergens: [],
        ingredents: INGREDIENTS,
        selectedIngredents: [],
        selectedCount: 0,
    })

    const { open, allergens, selectedAllergens, ingredents, selectedIngredents, selectedCount } = state;

    useEffect(() => {

    }, [])


    const onChangeSelectedAllergen = (allergen: AllergenItem) => {
        const curAllergens: AllergenItem[] = Object.assign(allergens);
        const index = curAllergens.findIndex(n => n.key === allergen.key);
        curAllergens[index].active = !allergens[index].active;
        let activeAllergens = selectedAllergens;
        if (curAllergens[index].active) {
            activeAllergens.push(curAllergens[index])
        }
        else {
            activeAllergens = activeAllergens.filter(n => n.key !== allergen.key)
        }
        setState({
            allergens: [...curAllergens],
            selectedAllergens: [...activeAllergens],
        })
    }

    const onChangeSelectedIngredents = (ingredent: AllergenItem) => {
        const curIngredents: AllergenItem[] = Object.assign(ingredents);
        const index = curIngredents.findIndex(n => n.key === ingredent.key);
        curIngredents[index].active = !ingredents[index].active;
        let activeIngredents = selectedIngredents;
        if (curIngredents[index].active) {
            activeIngredents.push(curIngredents[index])
        }
        else {
            activeIngredents = activeIngredents.filter(n => n.key !== ingredent.key)
        }
        setState({
            ingredents: [...curIngredents],
            selectedIngredents: [...activeIngredents],
        })
    }

    const onClose = () => {
        ServerShoppingCart.allergensAndIngredentsFilter = {
            allergen: selectedAllergens.map(n => n.key),
            other_detail_info: selectedIngredents.map(n => n.key),
        }
        setState({ open: false, selectedCount: selectedAllergens.length + selectedIngredents.length });
        onReRender();
    };

    const onOpen = () => setState({ open: true });

    return (
        <>
            <div className={`filter-icon`}>
                <IconButton onClick={onOpen}>
                    <Badge badgeContent={selectedCount}>
                        <IoFunnelSharp />
                    </Badge>
                </IconButton>
            </div>
            {
                open ?
                    <Dialog
                        className='filter-allergens-dialog'
                        maxWidth='md'
                        open={open}
                        onClose={onClose}
                        aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">
                            <div className='allergen-title-box'>
                                {i18n.t('menu_page_text_filter')}
                                <IconButton className='close-icon-btn' onClick={onClose}>
                                    <CloseSharp />
                                </IconButton>
                            </div>
                        </DialogTitle>
                        <DialogContent>
                            {/* 过敏原 */}
                            <div className='allergens-label-box'>
                                <span className='label-title'>
                                    {i18n.t('menu_page_text_allergen')}
                                </span>
                                <span className='label-message'>
                                    {i18n.t('menu_page_text_allergen_filter_label_message')}
                                </span>
                            </div>
                            <div className='allergens-actived-box' >
                                {
                                    selectedAllergens.map((item, index) => {
                                        return <>
                                            <div
                                                className={`active-allergen-item`}
                                                key={index}
                                            >
                                                <span>{i18n.t(item.text)}</span>
                                                <RiDeleteBin6Line onClick={() => onChangeSelectedAllergen(item)} />
                                            </div>
                                        </>
                                    })
                                }
                            </div>
                            <div className='allergens-content-box'>
                                {
                                    allergens.map((item, index) => {
                                        return <>
                                            <div
                                                className={`allergen-item ${item.active ? 'allergen-selected-item' : ''}`}
                                                key={index}
                                                onClick={() => onChangeSelectedAllergen(item)}
                                            >
                                                {i18n.t(item.text)}
                                            </div>
                                        </>
                                    })
                                }
                            </div>
                            {/* 其他菜品标识 */}
                            <div className='allergens-label-box'>
                                <span className='label-title'>
                                    {i18n.t('menu_page_text_ingredents')}
                                </span>
                                <span className='label-message'>
                                    {i18n.t('menu_page_text_ingredent_filter_label_message')}
                                </span>
                            </div>
                            <div className='allergens-actived-box'>
                                {
                                    selectedIngredents.map((item, index) => {
                                        return <>
                                            <div
                                                className={`active-allergen-item`}
                                                key={index}
                                            >
                                                <span>{i18n.t(item.text)}</span>
                                                <RiDeleteBin6Line onClick={() => onChangeSelectedIngredents(item)} />
                                            </div>
                                        </>
                                    })
                                }
                            </div>
                            <div className='allergens-content-box'>
                                {
                                    ingredents.map((item, index) => {
                                        return <>
                                            <div
                                                className={`allergen-item ${item.active ? 'allergen-selected-item' : ''}`}
                                                key={index}
                                                onClick={() => onChangeSelectedIngredents(item)}
                                            >
                                                {i18n.t(item.text)}
                                            </div>
                                        </>
                                    })
                                }
                            </div>
                        </DialogContent>
                    </Dialog>
                    :
                    null
            }
        </>
    )
}

type State = {
    open: boolean;
    allergens: AllergenItem[];
    selectedAllergens: AllergenItem[];
    ingredents: AllergenItem[],
    selectedIngredents: AllergenItem[],
    selectedCount: number;
}

interface Props {
    onReRender: () => void;
}